import jQuery from "jquery";
import CartJS from "./cart";

// eslint-disable-next-line no-unused-vars
const $ = jQuery;

// eslint-disable-next-line no-unused-expressions, no-shadow, func-names
!(($) => {
    // Quantity Updater
    // eslint-disable-next-line func-names
    $("#cartTemplateContainer, .header-icons-cart-container").on(
        "change",
        ".quantity-selector-dropdown",
        function (e) {
            const lineNumber = $(this).attr("data-line-number");
            const selectedQty = $(this).val();
            // eslint-disable-next-line no-undef
            CartJS.updateItem(lineNumber, selectedQty);
            e.preventDefault();
        },
    );
    // eslint-disable-next-line no-undef
})(jQuery);
